module.exports = __webpack_public_path__ + "img/icon_website@2x.967e1e0c.png";